export enum MolSocialMediaLogoTypeEnum {
  INSTAGRAM = "instagram",
  WHATSAPP = "whatsapp",
  MESSENGER = "messenger",
}
